/**
 * Where "/" — and any unknown path — sends a signed-in user.
 *
 * The Ad Dashboard is the landing page. Anyone without access to it lands on
 * the Overview instead, as everyone did before, rather than on an access-denied
 * screen. Sign-in returns to "/" so it always comes through here.
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { hasAccess } from '../../config/permissionResources';

export const AD_DASHBOARD_PATH = '/ads';
export const OVERVIEW_PATH = '/dashboard';

/** The landing path for a user. Same access rule the sidebar uses. */
export function landingPathFor(user: { permissions?: any[]; email?: string } | null | undefined): string {
  if (user && hasAccess(user.permissions || [], 'subscription_analytics', user.email)) return AD_DASHBOARD_PATH;
  return OVERVIEW_PATH;
}

const HomeRedirect: React.FC = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  return <Navigate to={landingPathFor(user)} replace />;
};

export default HomeRedirect;
